import lng from '@lightningjs/core';
import { Colors, Lightning, Router, Storage, Utils } from '@lightningjs/sdk';
import { likeMovie, startWatching, unlikeMovie } from '../../../api/movies/index';
import { addWatchListSeries, removeWatchlistSeries } from '../../../api/series';
import { store } from '../../../utils/globalData';
let watchList;
export default class SerieInfo extends Lightning.Component {
  static _template() {
    return {
      Item: {
        Image: {},
      },
      Wrapper: {
        MovieLink: {
          text: {
            fontSize: 35,
          },
        },
        ResumeProgress: {
          Progress: {},
        },
        TextBorder: { collision: true },
        Icon: {},
      },
    };
  }

  set serieId(val) {
    return (this._serieId = val);
  }

  set movieInfo(val) {
    return (this._movieInfo = val);
  }

  get movieInfo() {
    return this._movieInfo;
  }

  set seriesData(val) {
    return (this._seriesData = val);
  }

  get seriesData() {
    return this._seriesData;
  }

  set movieLink(val) {
    return (this._movieLink = val);
  }

  get movieLink() {
    return this._movieLink;
  }

  get _TextBorder() {
    return this.tag('TextBorder');
  }
  get _Icon() {
    return this.tag('Icon');
  }
  get _MovieLink() {
    return this.tag('MovieLink');
  }
  get _Image() {
    return this.tag('Item.Image');
  }

  set index(val) {
    this._index = val;
  }

  getFocus() {
    return this._TextBorder;
  }

  _focus() {
    super._focus();
    this._TextBorder.patch({
      texture: lng.Tools.getRoundRect(
        this._movieLink.width,
        70,
        13,
        5,
        Colors('#02AC25').get(),
        false
      ),
    });

    this.fireAncestors('$changeSeriesInfo', {
      title: this._movieInfo.name,
      description: this._seriesData.description,
      cover: this._seriesData.screenshots['1152x648'],
      category: this._seriesData.tags,
      duration: this._seriesData.duration,
      rating: this._seriesData.imdb.rating === null ? '−' : this._seriesData.imdb.rating.avg,
      votes: this._seriesData.imdb.rating === null ? '−' : this._seriesData.imdb.rating.num_votes,
      liked: this._seriesData.liked === null ? '' : this._seriesData.liked,
      contentRating: this._seriesData.content_rating,
    });
    this.fireAncestors('$changeVODInfo', {
      category: this._seriesData.tags,
    });
  }

  _unfocus() {
    super._unfocus();
    this._TextBorder.patch({
      texture:
        this._movieLink.id > 4
          ? lng.Tools.getRoundRect(this._movieLink.width, 70, 13, 5, Colors('#ffffff').get(), false)
          : lng.Tools.getRoundRect(
              this._movieLink.width,
              70,
              13,
              5,
              Colors('#000000').get(),
              false
            ),
    });
  }
  _convertToSeconds(duration) {
    let hours;
    let minutes;
    let seconds;
    const timeParts = duration.split(':');
    if (timeParts.length === 3) {
      hours = parseInt(timeParts[0]);
      minutes = parseInt(timeParts[1]);
      seconds = parseInt(timeParts[2]);
    }

    if (timeParts.length === 2) {
      hours = parseInt('00');
      minutes = parseInt(timeParts[0]);
      seconds = parseInt(timeParts[1]);
    }

    if (isNaN(hours) || isNaN(minutes) || isNaN(seconds)) {
      throw new Error('Invalid duration format. Hours, minutes, and seconds must be numbers.');
    }

    return hours * 3600 + minutes * 60 + seconds;
  }

  _handleHover() {
    this.fireAncestors('$setIndex', this._index);
    this._focus();
  }

  _handleUnhover() {
    this._unfocus();
  }

  _handleClick() {
    this._handleEnter();
  }

  _initialValue() {
    switch (this._movieLink.id) {
      case 0:
        let percentageCompleted =
          (this._seriesData.resume_time / this._convertToSeconds(this._seriesData.duration)) * 100;
        this.tag('ResumeProgress').patch({
          w: 165,
          h: 7,
          x: 300,
          y: 37,
          rect: true,
          zIndex: 1,
          color: Colors('#D6D6D6').get(),
        });
        this.tag('Progress').patch({
          w: (percentageCompleted / 100) * 165,
          h: 7,
          rect: true,
          color: Colors('#FB3A67').get(),
          zIndex: 10,
        });
      case 4:
        return this._movieInfo.on_watchlist ? Colors('#02AC25').get() : Colors('#ffffff').get();
      case 5:
        return this._seriesData.liked
          ? Colors('#02AC25').get()
          : (this.movieInfo.liked == null || this._seriesData.liked == false) &&
              Colors('#ffffff').get();

      case 6:
        return this._seriesData.liked == false
          ? Colors('#02AC25').get()
          : (this._seriesData.liked == null || this._seriesData.liked == true) &&
              Colors('#ffffff').get();

      default:
        return Colors('#ffffff').get();
    }
  }

  _firstEnable() {
    watchList = this._movieInfo.on_watchlist;
    this._MovieLink.patch({
      text: this._movieLink.title,
      color: this._initialValue(),
      x: 90,
      y: 16,
    });

    this._Icon.patch({
      x: this._movieLink.id > 4 ? 90 : 30,
      y: 21,
      w: 35,
      h: 35,
      texture: lng.Tools.getSvgTexture(Utils.asset(this._movieLink.image), 41, 41),
      color: this._initialValue(),
    });

    this._TextBorder.patch({
      texture:
        this._movieLink.id > 4
          ? lng.Tools.getRoundRect(this._movieLink.width, 70, 13, 5, Colors('#ffffff').get(), false)
          : lng.Tools.getRoundRect(
              this._movieLink.width,
              70,
              13,
              5,
              Colors('#000000').get(),
              false
            ),
    });

    this._Image.patch({
      rtt: true,
      zIndex: 2,
      w: this.w,
      h: this.h,
      texture: {
        type: lng.textures.ImageTexture,
        src: this._src,
        resizeMode: { type: 'cover', w: this.w, h: this.h },
      },
    });
  }

  _likeOrDislike() {}

  _changeValue() {
    let defaultValue;
    let contentPreferences;
    let profileId;
    let movieId;
    let movieInfo;
    let movieConfiguration;
    let subtitle;
    let audio;
    let credits_start_at;
    let profileInfo = Storage.get('profileInfo');
    localStorage.removeItem('CurrentVOD');
    switch (this.movieLink.id) {
      case 0:
        if (this._seriesData.locked) {
          this.fireAncestors('$showPaidTitleModal');
          return;
        }
        contentPreferences = Storage.get('content_preferences');
        profileId = Storage.get('profileId');
        movieId = this._serieId;
        movieInfo = this._seriesData;
        defaultValue = Storage.get(`audiosubtitles-${profileId}`);
        movieConfiguration = contentPreferences?.find(
          (preference) => preference.profileId === profileId && preference.serieId === movieId
        );
        subtitle = 'none';
        credits_start_at = movieInfo.languages[defaultValue.audio]?.credits_start_at;
        audio = movieInfo.languages[defaultValue.audio]?.hls_stream_url;
        if (defaultValue) {
          if (movieInfo.languages[defaultValue.audio]?.hls_stream_url) {
            audio = movieInfo.languages[defaultValue.audio].hls_stream_url;
            credits_start_at = movieInfo.languages[defaultValue.audio].credits_start_at;
          }
          if (movieInfo.languages[defaultValue.subtitle]?.subtitles_file) {
            subtitle = movieInfo.languages[defaultValue.subtitle].subtitles_file;
          }
        }
        if (movieConfiguration) {
          subtitle = 'none';
          audio = movieInfo.languages[defaultValue.audio]?.hls_stream_url;
          credits_start_at = movieInfo.languages[defaultValue.audio].credits_start_at;
          if (movieInfo.languages[movieConfiguration.subtitle]?.subtitles_file) {
            subtitle = movieInfo.languages[movieConfiguration.subtitle].subtitles_file;
          }
          audio = movieInfo.languages[movieConfiguration.audio]?.hls_stream_url;
          credits_start_at = movieInfo.languages[movieConfiguration.audio].credits_start_at;
        }
        if (profileInfo.autoplay) {
          Router.navigate(`player/${this._seriesData.id}`, {
            kind: 'series',
            currentTime: movieInfo.resume_time,
            subtitle: subtitle,
            videoUrl: audio,
            videoDuration: movieInfo.duration,
            introEndsAt: movieInfo.languages[defaultValue.audio].intro_ends_at,
            movieId: movieId,
            credits_start_at: credits_start_at,
          });
        } else {
          Router.navigate(`player/${this._seriesData.id}`, {
            kind: 'all',
            currentTime: movieInfo.resume_time,
            subtitle: subtitle,
            videoUrl: audio,
            videoDuration: movieInfo.duration,
            introEndsAt: movieInfo.languages[defaultValue.audio].intro_ends_at,
            movieId: movieId,
            credits_start_at: credits_start_at,
          });
        }
        startWatching(this._seriesData.id);
        break;
      case 1:
        if (this._seriesData.locked) {
          this.fireAncestors('$showPaidTitleModal');
          return;
        }

        movieInfo = this._seriesData;
        contentPreferences = Storage.get('content_preferences');
        profileId = Storage.get('profileId');
        (movieId = movieInfo.id), (movieInfo = this._seriesData);
        defaultValue = Storage.get(`audiosubtitles-${profileId}`);
        movieConfiguration = contentPreferences?.find(
          (preference) => preference.profileId === profileId && preference.serieId === movieId
        );
        subtitle = 'none';
        audio = movieInfo.languages[defaultValue.audio]?.hls_stream_url;
        credits_start_at = movieInfo.languages[defaultValue.audio]?.credits_start_at;
        if (defaultValue) {
          if (movieInfo.languages[defaultValue.audio]?.hls_stream_url) {
            audio = movieInfo.languages[defaultValue.audio].hls_stream_url;
            credits_start_at = movieInfo.languages[defaultValue.audio]?.credits_start_at;
          }
          if (movieInfo.languages[defaultValue.subtitle]?.subtitles_file) {
            subtitle = movieInfo.languages[defaultValue.subtitle].subtitles_file;
          }
        }
        if (movieConfiguration) {
          subtitle = 'none';
          audio = movieInfo.languages[defaultValue.audio]?.hls_stream_url;
          credits_start_at = movieInfo.languages[defaultValue.audio]?.credits_start_at;
          if (movieInfo.languages[movieConfiguration.subtitle]?.subtitles_file) {
            subtitle = movieInfo.languages[movieConfiguration.subtitle].subtitles_file;
          }
          audio = movieInfo.languages[movieConfiguration.audio]?.hls_stream_url;
          credits_start_at = movieInfo.languages[movieConfiguration.audio]?.credits_start_at;
        }
        if (profileInfo.autoplay) {
          Router.navigate(`player/${this._seriesData.id}`, {
            kind: 'series',
            currentTime: 0,
            subtitle: subtitle,
            videoUrl: audio,
            videoDuration: this._seriesData.duration,
            introEndsAt: this._seriesData.languages[defaultValue.audio].intro_ends_at,
            movieId: this._seriesData.id,
            credits_start_at: null,
          });
        } else {
          Router.navigate(`player/${this._seriesData.id}`, {
            kind: 'all',
            currentTime: 0,
            subtitle: subtitle,
            videoUrl: audio,
            videoDuration: this._seriesData.duration,
            introEndsAt: this._seriesData.languages[defaultValue.audio].intro_ends_at,
            movieId: this._seriesData.id,
          });
        }
        startWatching(this._seriesData.id);
        break;
      case 2:
        Storage.set('video', { id: this._movieInfo.id, watchList: watchList });
        Router.navigate(`series/${this._movieInfo.id}/episodes`);
        break;
      case 3:
        Router.navigate(`series/${this._movieInfo.id}/audio-subtitles`, {
          serieId: this._serieId,
        });
        break;
      case 4:
        store.setMyListFlag(false);
        this._MovieLink.text.text == 'Added from My List'
          ? removeWatchlistSeries(this._movieInfo.id)
              .then(() => {
                this._MovieLink.patch({
                  color: Colors('#FFFFFF').get(),
                  text: { text: 'Add to My List' },
                });
                this._Icon.patch({
                  color: Colors('#FFFFFF').get(),
                });
                watchList = false;
              })
              .catch((error) => {
                console.error(error);
              })
          : addWatchListSeries(this._movieInfo.id)
              .then(() => {
                this._MovieLink.patch({
                  color: Colors('#02AC25').get(),
                  text: { text: 'Added from My List' },
                });
                this._Icon.patch({
                  color: Colors('#02AC25').get(),
                });
                watchList = true;
              })
              .catch((error) => {
                console.error(error);
              });
    }
  }
  _handleEnter() {
    this._likeOrDislike();
    this._changeValue();
    const movieItems = this.parent.children;
    movieItems.forEach((item) => {
      const icon = item.tag('Icon');
      if (item === this && (this._movieLink.id === 5 || this._movieLink.id === 6)) {
        // Define the color that should be applied if this item is clicked
        let targetColor =
          this._movieLink.id === 5 ? Colors('#02AC25').get() : Colors('#02AC25').get();
        // If the item is already the target color, set it to white; otherwise, apply the target color
        let color = icon.color === targetColor ? Colors('#FFFFFF').get() : targetColor;
        icon.patch({
          color: color,
        });
        if (this._movieLink.id === 5) {
          likeMovie(this._seriesData.id);
        } else if (this._movieLink.id === 6) {
          unlikeMovie(this._seriesData.id);
        }
      } else if (this._movieLink.id === 5 || this._movieLink.id === 6) {
        // Set white color for other like/dislike items
        icon.patch({
          color: Colors('#FFFFFF').get(),
        });
      }
    });
  }
}
